/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, makeStyles } from "@material-ui/core/";
import { useContext, useState } from "react";
import { config as url } from "../../common/config";
import FetchDataContext from "../../context/fetchData/fetchDataContext";
import FormOnTask from "./FormOnTask";
import OptionHandle from "./OptionHandle";
import TableOnTask from "./TableOnTask";

const useStyles = makeStyles((theme) => ({
	root: {
		paddingLeft: "2rem",
		paddingRight: "2rem",
		paddingBottom: "2rem",
		[theme.breakpoints.down("sm")]: {
			paddingLeft: "1rem",
			paddingRight: "1rem",
		},
	},
}));

const Task = ({ sendMessages }) => {
	const classes = useStyles();
	const BaseUrl = `${url.list_issue}`;
	const fetchData = useContext(FetchDataContext);
	const {
		getDataTables,
		addDataForm,
		updateData,
		deleteData,
		refreshData,
		tableRef,
		SingleHandleOptions,
		MultiHandleOptionsTask,
		stateOption,
		setStateOption,
		singleOption,
	} = fetchData;

	const [state, setState] = useState({
		openAdd: false,
		pageSize: 10,
	});
	const [optionChange, setOptionChange] = useState({
		idlayanan: 0,
		idstatus: 1,
		idkategori: 0,
	});

	const { openAdd, pageSize } = state;

	const handleOpenCloseFormAdd = () => {
		setState({ ...state, openAdd: !openAdd });
		setStateOption({ ...stateOption, optionResult: null });
	};

	const fetchAPI = async (action, data) => {
		let result;
		if (action === "addForm")
			result = await addDataForm(
				`${BaseUrl}/add_issue`,
				data,
				handleOpenCloseFormAdd
			);
		if (action === "edit")
			result = await updateData(
				`${BaseUrl}/edit_issue?id=${data.id}`,
				data,
				handleOpenCloseFormAdd
			);
		if (action === "delete")
			result = await deleteData(`${BaseUrl}/delete_issue?id=${data.id}`, data);

		return result;
	};

	return (
		<Grid direction="column" alignItems="center" className={classes.root}>
			<OptionHandle
				stateOption={stateOption && stateOption}
				state={optionChange}
				setState={setOptionChange}
				handleSearch={refreshData}
				MultiHandleOptionsTask={MultiHandleOptionsTask}
			/>
			<TableOnTask
				getDataTable={getDataTables}
				BaseUrl={BaseUrl}
				fetchAPI={fetchAPI}
				pageSize={pageSize}
				tableRef={tableRef}
				modalAdd={handleOpenCloseFormAdd}
				state={optionChange}
			/>
			<FormOnTask
				sendMessages={sendMessages}
				stateOption={stateOption}
				setStateOption={setStateOption}
				MultiHandleOptionsTask={MultiHandleOptionsTask}
				SingleHandleOptions={SingleHandleOptions}
				open={openAdd}
				fetchAPI={fetchAPI}
				singleOption={singleOption}
				handleClose={handleOpenCloseFormAdd}
			/>
		</Grid>
	);
};
export default Task;
